import { IEventDetailedRound, IRoundGame } from '../../store/admin/eventRounds/store';

type TGetEnrollmentGame = (
  round: IEventDetailedRound,
  enrollment: number
) => IRoundGame | undefined;

export const getEnrollmentGame: TGetEnrollmentGame = (round, enrollmentId) => {
  const games: IRoundGame[] = (round.groups || []).flatMap(group => group.games);

  const gameFound = games.find(game => game.enrollment === enrollmentId);

  return gameFound;
};
